// @vendors
const get = require("lodash/object/get");
const map = require("lodash/collection/map");
const trim = require("lodash/string/trim");
const reduce = require("lodash/collection/reduce");
const moment = require('moment');

// @actions
const signaturePatternActions = require("actions/signaturePattern");
const brokerMiFIDProductsActions = require("mifid/actions/brokerMiFIDProducts");
const errorActions = require("actions/brokerError");

// @helpers
const apiURLBuilder = require("core/apiURLBuilder");
const { APIGet, APIPost } = require("utilities/APIRequestHelper");
const {
    isRenderStep0,
    setOrderNumber,
} = require("mifid/utilities/mifidValidHelper");
const { isPrivateEquityTest } = require('mifid/utilities/mifidPrivateEquityHelper');
//const Storage = require('utilities/storage');
const { getLanguage, formatText } = require("core/i18n").i18n;
const { getCCOfficeChannel } = require("utilities/contactCenter/printerHelper");
import  { conditionalValueOrHyphen } from 'utilities/valueHelper';
import { buildFormattedDate } from 'utilities/dateHelper';

// @tagging
const { buildTags } = require("../utilities/mifidTaggingHelper");
const { taggingEventHandled } = require("utilities/taggingEventHandled");
const { PROC_BROKER_CONVENIENCE_TEST } = require("utilities/tagging");

// @constants
const {
    API_CHANNEL,
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    FOURTH_STEP,
    BROKER_MIFID_ANSWER_ACTION,
    BROKER_MIFID_REJECT_ACTION,
    BROKER_CONVENIENCE_MIFID_FUND,
    MYPROFILE_BROKER_CONVENIENCE_MIFID_TEST_WIZARD_URL,
    BROKER_CORPORATE_OPERATIONS_URL,
    BROKER_MIFID_VERSION_1,
    BROKER_MIFID_VERSION_2,
    BROKER_CONVENIENCE_MIFID_EMPTY_FEE_NUMBERS,
    DATE_FORMAT_API2,
    DATE_FORMAT_SLASHED_ES,
    DATE_FORMAT_COMPLETE,
} = require("constants/index");
const {
    BROKER_CONVENIENCE_MIFID_TEST_RESULT_DISPLAYED,
    BROKER_CONVENIENCE_MIFID_TEST_VALIDATE_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_SET_VISIBLE_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_HARD_RESET,
    BROKER_CONVENIENCE_MIFID_TEST_RESET,
    BROKER_CONVENIENCE_MIFID_TEST_START,
    BROKER_CONVENIENCE_MIFID_TEST_FINISH_LOADING,
    BROKER_CONVENIENCE_MIFID_TEST_FINISH_ERROR,
    BROKER_CONVENIENCE_MIFID_TEST_FINISH,
    BROKER_CONVENIENCE_MIFID_TEST_OMIT,
    BROKER_CONVENIENCE_MIFID_TEST_CONSULT,
    BROKER_CONVENIENCE_MIFID_TEST_RETAKE_TEST,
    BROKER_CONVENIENCE_MIFID_TEST_FETCH_GET_TEST_SUCCESS,
    BROKER_CONVENIENCE_MIFID_TEST_STEPS_INITIAL_STEPS,
} = require("constants/actionTypes");

const {
    BROKER_CONVENIENCE_MIFID_TEST_CONTINUE_WITH_DISAPPROVED_TEST,
    BROKER_CONVENIENCE_MIFID_TEST_REVIEW_DISAPPROVED_TEST,
    BROKER_CONVENIENCE_MIFID_TEST_FETCH_GET_TEST_FETCHING,
    BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_FETCHING,
    BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_SUCCESS_APPROVED,
    BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_SUCCESS_DISAPPROVED,
    BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_ERROR,
    BROKER_CONVENIENCE_MIFID_TEST_RESET_TEST_SCORE_STATUS,
    BROKER_CONVENIENCE_MIFID_TEST_UPDATE_CATEGORY_AND_SUBCATEGORY,
    BROKER_CONVENIENCE_MIFID_TEST_UPDATE_ANSWER,
    BROKER_CONVENIENCE_MIFID_TEST_GO_TO_CONFIRMATION_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_GO_TO_FINISH_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_GO_TO_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_REVIEWING_TEST,
    BROKER_CONVENIENCE_MIFID_TEST_DISABLED_BUTTON,
    BROKER_CONVENIENCE_MIFID_TEST_ENABLE_BUTTON,
    BROKER_CONVENIENCE_MIFID_TEST_SHOW_MODAL,
    BROKER_CONVENIENCE_MIFID_TEST_UPDATE_LIST_ANSWER_WITH_COHERENCE,
    BROKER_CONVENIENCE_MIFID_TEST_IS_ACCORDION_ANSWER,
    BROKER_CONVENIENCE_MIFID_TEST_SHOW_PROFESSIONAL_EXPERIENCE_MODAL,
    BROKER_CONVENIENCE_MIFID_TEST_SHOW_DIFFERENCE_MODAL,
    BROKER_CONVENIENCE_MIFID_TEST_HIDE_DIFFERENCE_MODAL,
    BROKER_CONVENIENCE_MIFID_TEST_SHOW_PROFESSIONAL_EXPERIENCE_MODAL_WARNING,
    BROKER_CONVENIENCE_MIFID_TEST_HIDE_FIRST_TIME_POP_UP,
    BROKER_CONVENIENCE_MIFID_TEST_GET_INVESTMENT_EXPERIENCE_SUCCESS,
    BROKER_CONVENIENCE_MIFID_TEST_HANDLE_CLOSE_MODAL_INVESTMENT_EXPERIENCE,
    BROKER_CONVENIENCE_MIFID_TEST_ADD_PRIVATE_EQUITY_DISCLAIMERS,
} = require("mifid/constants/actionTypes");

// @constants
const {
    QUESTION_TO_COHERENCE_CONTROL,
    QUESTIONS_TO_EVALUATE_TO_PREVIOUS_TEST,
    QUESTIONS_TO_EVALUATE_TO_PREVIOUS_TEST_V3,
    QUESTION_TO_NOT_CLEAN,
    ACCORDION_TYPE,
    QUESTION_204,
    ANSWER_205,
    GENERAL_TEST_STUDY_ANSWER_WEIGHTS,
    PRIVATE_EQUITY_STUDY_ANSWER_WEIGHTS,
    QUESTIONS_EQUIVALENCE_V3_V2
} = require("mifid/constants/constants");

const {
    MIFID_TEST_CONTRACTED_PRODUCTS_COHERENCE_CONTROL,
    CONVENIENCE_TEST_V3,
} = require("constants/flagBasedFeatures");

const addPrivateEquityDisclaimers = () => (dispatch, getState) => {
    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const lastExecutionDate = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'lastExecutionDate']);
    const executionDate = moment(lastExecutionDate, DATE_FORMAT_SLASHED_ES);
    const executionDateFormatted = conditionalValueOrHyphen(
        executionDate.isValid(),
        buildFormattedDate(executionDate, DATE_FORMAT_COMPLETE)
    );
    const scoreText = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'convenienceEvaluationDisclaimer'])
        ? immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'convenienceEvaluationDisclaimer'])
        : immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'scoreText']);

    const disclaimer1 = {
        id: null,
        description: formatText('brokerAlternativeFunds-disclaimer1Text', [ scoreText, executionDateFormatted ]),
        phrase: null,
    }

    const disclaimer2 = {
        id: null,
        description: formatText('brokerAlternativeFunds-disclaimer2Text'),
        phrase: null,
    }

    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_ADD_PRIVATE_EQUITY_DISCLAIMERS,
        payload: { disclaimers: [disclaimer1, disclaimer2] },
    });

}

const resultDisplayed = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_RESULT_DISPLAYED,
        payload: {},
    });
};

function validateUIStep(step, stepsState) {
    return {
        type: BROKER_CONVENIENCE_MIFID_TEST_VALIDATE_STEP,
        payload: {
            step,
            stepsState,
        },
    };
}

const setVisibleStep = (step) => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_SET_VISIBLE_STEP,
        payload: {
            step,
        },
    });
};

const hardReset = () => ({ type: BROKER_CONVENIENCE_MIFID_TEST_HARD_RESET });

const reset = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_RESET,
        payload: {},
    });
};

function questionToRequest(
    action,
    immQuestion,
    questionKey,
    answersKey,
    selectedAnswerKey
) {
    const userOmmitedQuestion = action === BROKER_MIFID_REJECT_ACTION;
    const selectedAnswer = immQuestion.get(selectedAnswerKey);

    return {
        descripcion: immQuestion.get(questionKey),
        id: immQuestion.get("id"),
        orden: setOrderNumber(immQuestion.get("orden")) || "SIN ORDEN",
        respuestasArray: {
            respuestasArray: immQuestion
                .get(answersKey)
                .toJS()
                .map((answer) => {
                    let value;

                    if (userOmmitedQuestion) {
                        value = null;
                    } else {
                        value = answer.id === selectedAnswer ? "S" : "N";
                    }

                    return {
                        descripcion: answer.description,
                        id: answer.id,
                        seleccionado: value,
                    };
                }),
        },
    };
}

const questionsToMifid1Request = (immBrokerConvenienceMiFIDTest, action) => {
    let firstStep, secondStep, thirdStep, zeroStep;
    const renderStep0 = isRenderStep0();
    if (renderStep0) {
        zeroStep = FIRST_STEP;
        firstStep = SECOND_STEP;
        secondStep = THIRD_STEP;
        thirdStep = FOURTH_STEP;
    } else {
        firstStep = FIRST_STEP;
        secondStep = SECOND_STEP;
        thirdStep = THIRD_STEP;
    }
    const immSteps = immBrokerConvenienceMiFIDTest.get("steps");
    const immChangeReasonQuestion = renderStep0
        ? immSteps.get(zeroStep).get("updateReason")
        : null;
    const immStudyQuestion = immSteps.get(firstStep).get("study");
    const immExperienceQuestion = immSteps.get(firstStep).get("experience");
    const immFinancialQuestion = immSteps
        .get(secondStep)
        .get("financialCulture");
    const immProductsQuestions = immSteps.get(thirdStep).get("products");
    const immProductsQuestionsToRequest = immProductsQuestions
        .map((immQuestion) =>
            questionToRequest(action, immQuestion, "name", "answers", "answer")
        )
        .toJS();

    let questions = renderStep0
        ? [
            questionToRequest(
                action,
                immChangeReasonQuestion,
                "question",
                "answers",
                "answer"
            ),
        ] : [];
    questions = [
        ...questions,
        questionToRequest(
            action,
            immStudyQuestion,
            "question",
            "answers",
            "answer"
        ),
        questionToRequest(
            action,
            immExperienceQuestion,
            "question",
            "answers",
            "answer"
        ),
        questionToRequest(
            action,
            immFinancialQuestion,
            "question",
            "answers",
            "answer"
        ),
        ...immProductsQuestionsToRequest,
    ];
    return questions;
};

const questionsToMifid2Request = (immBrokerConvenienceMiFIDTest, action) => {
    const mifid1Questions = questionsToMifid1Request(
        immBrokerConvenienceMiFIDTest,
        action
    );

    return {
        question: map(mifid1Questions, (question) => {
            const answers = get(question, "respuestasArray.respuestasArray");

            return {
                id: get(question, "id"),
                description: get(question, "descripcion"),
                orden: get(question, "orden"),
                answer: map(answers, (answer) => {
                    return {
                        id: get(answer, "id"),
                        description: get(answer, "descripcion"),
                        selected: get(answer, "seleccionado"),
                    };
                }),
            };
        }),
    };
};

const formatTestQuestions = (immBrokerConvenienceMiFIDTest) => {
    const immTest = immBrokerConvenienceMiFIDTest.getIn(["test", "schema"]);
    let testQuestion = [];
    immTest.get("categories").forEach((category) => {
        category.get("subCategories").forEach((subCategory) => {
            subCategory.get("sections").forEach((section) => {
                section.get("questions").forEach((question) => {
                    testQuestion.push({
                        id: question.get("id"),
                        description: question.get("description"),
                        orden: question.get("orden"),
                        answer: question
                            .get("answer")
                            .toJS()
                            .map((ans) => {
                                return {
                                    id: ans.id,
                                    description: ans.description,
                                    selected: ans.selected,
                                };
                            }),
                    });
                });
            });
        });
    });
    const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'testToEvaluate','tipoTest'])
    if (!isPrivateEquityTest(testToEvaluateId)) {
        const experienceQuestion = testQuestion.find((q) => q.id === "204");
        const highExperienceAnswer = experienceQuestion && experienceQuestion.answer.find(
            (a) => a.id === "205"
        );
        const shouldCleanTest =
            !!highExperienceAnswer && highExperienceAnswer.selected === "S";
        if (shouldCleanTest) {
            testQuestion = testQuestion.map((question) => {
                if (!QUESTION_TO_NOT_CLEAN.includes(question.id)) {
                    const cleanedQuestion = {
                        ...question,
                        answer: question.answer.map((a) => ({
                            ...a,
                            selected: "",
                        })),
                    };
                    return cleanedQuestion;
                }
                return question;
            });
        }
    }
    return { question: testQuestion };
};

const mifid2SubmitResponses =
    (clientEmail, token, action, history) => (dispatch, getState) => {
        const immBrokerConvenienceMiFIDTest =
            getState().brokerConvenienceMiFIDTest;
        const isRejecting = action === BROKER_MIFID_REJECT_ACTION;
        const isManual = immBrokerConvenienceMiFIDTest.getIn([
            "operationData",
            "isManualTest",
        ]);
        const eventCode = immBrokerConvenienceMiFIDTest.getIn([
            "mifidv2",
            "eventCode",
        ]);
        const eventCodeOrDefault = eventCode || "A";
        const isEventCodeMissing = !eventCode;
        const url = isManual
            ? apiURLBuilder.getURL("brokerMiFIDInsertTestByPerson")
            : apiURLBuilder.getURL("brokerMiFIDInsertTest");

        const immFlagBasedFeatures = getState().flagBasedFeatures;
        const testV3FF = immFlagBasedFeatures.get(CONVENIENCE_TEST_V3)
        const version = testV3FF ? 3 : 2;

        let requestData = {
            header: {
                version: version,
            },
            query: {
                language: getLanguage().toLowerCase(),
                canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
                eventCode:
                    isRejecting && isEventCodeMissing
                        ? null
                        : eventCodeOrDefault,
                feeNumbers: immBrokerConvenienceMiFIDTest.getIn([
                    "mifidv2",
                    "feeNumbers",
                ]),
                valueCode: immBrokerConvenienceMiFIDTest.getIn([
                    "mifidv2",
                    "valueCode",
                ]),
                isinId: immBrokerConvenienceMiFIDTest.getIn([
                    "mifidv2",
                    "isinId",
                ]),
                marketId: immBrokerConvenienceMiFIDTest.getIn([
                    "mifidv2",
                    "marketId",
                ]),
                operationCode: immBrokerConvenienceMiFIDTest.getIn([
                    "mifidv2",
                    "getTestOperationCode",
                ]),
                test: isRejecting
                    ? null
                    : formatTestQuestions(immBrokerConvenienceMiFIDTest),
            },
        };

        if (!isRejecting) {
            requestData.query.signature = {
                dataToken: token,
            };
        }

        return APIPost(dispatch, url, requestData).catch((response) => {
            const errorKey = get(response, ["body", "error"], "");
            dispatch(
                errorActions.show("brokerAPIErrors-" + errorKey, true, history)
            );
        });
    };

const mifid1SubmitResponses =
    (clientEmail, token, action, history) => (dispatch, getState) => {
        const immBrokerConvenienceMiFIDTest =
            getState().brokerConvenienceMiFIDTest;
        const url = apiURLBuilder.getURL("brokerMifidTestConveniencia");

        let requestData = {
            email: clientEmail,
            test: {
                accion: action || BROKER_MIFID_ANSWER_ACTION,
                idProducto: immBrokerConvenienceMiFIDTest.get("productId"),
                preguntasArray: {
                    preguntasArray: questionsToMifid1Request(
                        immBrokerConvenienceMiFIDTest,
                        action
                    ),
                },
            },
        };

        if (action !== BROKER_MIFID_REJECT_ACTION) {
            requestData.firma = {
                dataToken: token,
            };
        }

        return APIPost(dispatch, url, { query: requestData }).catch(
            (response) => {
                const errorKey = get(response, ["body", "error"], "");
                dispatch(
                    errorActions.show(
                        "brokerAPIErrors-" + errorKey,
                        true,
                        history
                    )
                );
            }
        );
    };

const submitResponses =
    (clientEmail, token, action, history) => (dispatch, getState) => {
        const immBrokerConvenienceMiFIDTest =
            getState().brokerConvenienceMiFIDTest;
        const isUsingMifidv2 =
            immBrokerConvenienceMiFIDTest.get("mifidVersion") ===
            BROKER_MIFID_VERSION_2;

        if (isUsingMifidv2) {
            return dispatch(
                mifid2SubmitResponses(clientEmail, token, action, history)
            );
        }

        return dispatch(
            mifid1SubmitResponses(clientEmail, token, action, history)
        );
    };

const finishError = (error) => ({
    type: BROKER_CONVENIENCE_MIFID_TEST_FINISH_ERROR,
    payload: { error },
});

const retakeTest = () => ({
    type: BROKER_CONVENIENCE_MIFID_TEST_RETAKE_TEST,
});

const finishReturnFinalResult = (response) => (dispatch) => {
    return dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_FINISH,
        payload: { response },
    });
};

const validSignaturePattern =
    (clientEmail, token, action, history) => (dispatch, getState) => {
        const immFlagBasedFeatures = getState().flagBasedFeatures;
        const testV3FF = immFlagBasedFeatures.get(CONVENIENCE_TEST_V3)
        return dispatch(
            submitResponses(clientEmail, token, action, history)
        ).then(
            (response) => {
                let data = response;
                const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
                const testToEvaluate = immBrokerConvenienceMiFIDTest.getIn(["mifidv2", "testToEvaluate", "tipoTest"]);
                let url, requestData
                if (isPrivateEquityTest(testToEvaluate)) {
                    url = apiURLBuilder.getURL('brokerMiFIDUSPerson')
                    const isinId = immBrokerConvenienceMiFIDTest.getIn([
                        "mifidv2",
                        "isinId",
                    ])
                    const marketId =immBrokerConvenienceMiFIDTest.getIn([
                        "mifidv2",
                        "marketId",
                    ])
                    requestData = {
                        language: getLanguage().toLowerCase(),
                        canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
                        isinId,
                        marketId
                    };
                    APIGet(dispatch, url, { query: requestData })
                        .then((usPersonResponse) => {
                            const operationCode = usPersonResponse.operationCode
                            const getTestrequestData = {
                                header: {
                                    version: testV3FF ? 3 : 2,
                                },
                                query: {
                                    language: getLanguage().toLowerCase(),
                                    canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
                                    operationCode,
                                    isinId,
                                    marketId,
                                },

                            };
                            APIGet(dispatch, apiURLBuilder.getURL('brokerMiFIDGetTest'), getTestrequestData )
                            .then((testResponse) => {
                                const testFiltered = testResponse.getTestListado.find(
                                    (test) => test.tipoTest === testToEvaluate

                                );
                                data = {
                                    ...data,
                                    lastDateTest: testFiltered.lastDateTest,
                                    newReason: testFiltered.reason
                                }
                                dispatch(finishReturnFinalResult(data))
                            })
                            .catch((error) => dispatch(finishError(error)))

                        }).catch((error) => dispatch(finishError(error)))
                } else {
                    url = apiURLBuilder.getURL('brokerMiFIDGetTestByPerson')
                    requestData = {
                        header: {
                            version: testV3FF ? 3 : 2,
                        },
                        query: {
                            language: getLanguage().toLowerCase()
                        }
                    };
                    APIGet(dispatch, url, requestData)
                        .then((response) => {
                            const testFiltered = response.getTestByPersonResponseListado.find(
                                (test) => test.tipoTest === testToEvaluate

                            );
                            data = {
                                ...data,
                                lastDateTest: testFiltered ? testFiltered.dateTest : null,
                                newReason: testFiltered ? testFiltered.reason : null
                            }
                            dispatch(finishReturnFinalResult(data))
                        })
                        .catch((error) => dispatch(finishError(error))
                        );
                }
            },
            (error) => dispatch(finishError(error))
        );
    };

const startTestIfRequired =
    ({
        history,
        productName,
        productUrl,
        productId,
        urlContinueOperation,
        operationData = {},
        cancelPath,
        mifidVersion = BROKER_MIFID_VERSION_1,
    }) =>
    (dispatch, getState) => {
        const immBrokerConvenienceMiFIDTest =
            getState().brokerConvenienceMiFIDTest;
        const immBrokerMiFIDProducts = getState().brokerMiFIDProducts;
        const { isManualTest, hideAlreadyPerformTestResult } = operationData;
        const requiresTest =
            immBrokerConvenienceMiFIDTest.get("requiresTest") ||
            immBrokerMiFIDProducts.getIn([
                "products",
                productId,
                "requiresTest",
            ]);

        // (franco.montenegro) Manual MiFID test must always run
        if (!isManualTest && hideAlreadyPerformTestResult && !requiresTest) {
            const notUsingMiFIDv2 =
                immBrokerConvenienceMiFIDTest.get("mifidVersion") !==
                BROKER_MIFID_VERSION_2;

            // (franco.montenegro) MiFID2 must always display the disclaimer
            if (notUsingMiFIDv2) {
                return;
            }
        }

        // (franco.montenegro)
        // MiFID must not be displayed if it has been completed, omitted or if the disclaimer was already displayed.
        // Example: Buy Warrant -> Display MiFID -> Finish | Omit -> Continue & redirect to Buy Warrant
        // Note: If the user leaves the page at which MiFID redirected to, the test must be displayed
        // again when the user returns
        if (
            !isManualTest &&
            immBrokerConvenienceMiFIDTest.get("resultDisplayed")
        ) {
            return;
        }

        dispatch({
            type: BROKER_CONVENIENCE_MIFID_TEST_START,
            payload: {
                operationType: operationData.operationType,
                productName,
                productUrl,
                productId,
                urlContinueOperation,
                operationData,
                cancelPath,
                mifidVersion,
            },
        });

        if (!isManualTest) {
            history.replace(MYPROFILE_BROKER_CONVENIENCE_MIFID_TEST_WIZARD_URL);
        } else {
            history.push(MYPROFILE_BROKER_CONVENIENCE_MIFID_TEST_WIZARD_URL);
        }
    };

const startMifidVersion1 =
    ({
        history,
        productName,
        productUrl,
        productId,
        urlContinueOperation,
        operationData = {},
        cancelPath,
    }) =>
    (dispatch) => {
        const testIfRequired = startTestIfRequired({
            history,
            productName,
            productUrl,
            productId,
            urlContinueOperation,
            operationData,
            cancelPath,
        });

        if (operationData.hideAlreadyPerformTestResult) {
            dispatch(
                brokerMiFIDProductsActions.fetchMiFIDProduct(productId, history)
            ).then(() => dispatch(testIfRequired));
        } else {
            dispatch(testIfRequired);
        }
    };

const startMiFIDVersion2 =
    ({
        history,
        productName,
        productUrl,
        productId,
        urlContinueOperation,
        operationData = {},
        cancelPath,
    }) =>
    (dispatch) => {
        dispatch(
            startTestIfRequired({
                history,
                productName,
                productUrl,
                productId,
                urlContinueOperation,
                operationData,
                cancelPath,
                mifidVersion: BROKER_MIFID_VERSION_2,
            })
        );
    };

/**
 *
 * @param {object} history History object from router
 * @param {string} productName Name of product to be used in breadcrumb
 * @param {string} productUrl Product url to be used as link in breadcrumb
 * @param {string} productId MiFID product id
 * @param {string|string[]} urlContinueOperation Url used in final button to continue. Use an array
 * to persist the data of MiFID for several URLs. Notice, only the first URL will be used for the redirect/button.
 * @param {object} operationData
 * @param {bool} operationData.hideAlreadyPerformTestResult Hide disclaimer if the test was already
 * completed and no further action is required
 * @param {bool} operationData.isManualTest Tests manually initiated by users will always run
 * @param {string} operationData.operationType Specific to operations that can't continue with
 * an url (such as futures access platform)
 * @param {object[]} operationData.breadcrumb Specify custom breadcrumb. Example: [{ text: 'Label', url: 'url.com' }]
 * @param {string|undefined} cancelPath Path to redirect when the users click on Cancel
 */
const start =
    (
        history,
        productName,
        productUrl,
        productId,
        urlContinueOperation,
        operationData = {},
        cancelPath
    ) =>
    (dispatch, getState) => {
        const immBrokerConvenienceMiFIDTest =
            getState().brokerConvenienceMiFIDTest;
        const usingMifidv2 =
            immBrokerConvenienceMiFIDTest.get("mifidVersion") ===
            BROKER_MIFID_VERSION_2;
        const isManualTest = get(operationData, "isManualTest");

        const params = {
            history,
            productName,
            productUrl,
            productId,
            urlContinueOperation,
            operationData,
            cancelPath,
        };

        // (franco.montenegro) Use mifid 2 for manual tests
        if (usingMifidv2 || isManualTest) {
            dispatch(startMiFIDVersion2(params));
        } else {
            dispatch(startMifidVersion1(params));
        }
    };

const startFromCorporateOperation =
    (productName, productUrl, productId, operationType, operationData) =>
    (dispatch) => {
        dispatch({
            type: BROKER_CONVENIENCE_MIFID_TEST_START,
            payload: {
                productId,
                productUrl,
                operationType,
                operationData,
                cancelPath: BROKER_CORPORATE_OPERATIONS_URL,
            },
        });
    };

const startFromFund =
    (productName, productUrl, productId, fundId) => (dispatch) => {
        dispatch({
            type: BROKER_CONVENIENCE_MIFID_TEST_START,
            payload: {
                productName,
                productId,
                operationType: BROKER_CONVENIENCE_MIFID_FUND,
                operationData: { fundId },
            },
        });
    };

const validateSignaturePatternHook = () => (dispatch, getState) => {
    return signaturePatternActions
        .validateAndExecute(dispatch, getState, () => {})
        .then((token) => (token ? token : Promise.reject()));
};

const finish = (clientEmail, action, history) => (dispatch, getState) => {
    if (getState().brokerConvenienceMiFIDTest.get("loading")) {
        return;
    }

    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_FINISH_LOADING,
        payload: {},
    });

    if (action === BROKER_MIFID_REJECT_ACTION) {
        return dispatch(
            validSignaturePattern(clientEmail, undefined, action, history)
        );
    }

    return dispatch(validateSignaturePatternHook()).then(
        (token) =>
            dispatch(
                validSignaturePattern(clientEmail, token, action, history)
            ),
        (error) => dispatch(finishError(error))
    );
};

const omit = () => (dispatch, getState) => {
    const { currentStepCategory, currentStepSubCategory, immCategories } =
        getStoreForValidateTest(getState);
    const tags = buildTags({
        immCategories,
        currentStepCategory,
        currentStepSubCategory,
    });
    taggingEventHandled(
        PROC_BROKER_CONVENIENCE_TEST,
        "rejectTest",
        "",
        tags.currentSubCategoryTag || tags.currentCategoryTag
    );

    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_OMIT,
        payload: {},
    });
};

const consult =
    (productId, questions, fecha, evaluationDescription) => (dispatch) => {
        dispatch({
            type: BROKER_CONVENIENCE_MIFID_TEST_CONSULT,
            payload: { productId, questions, fecha, evaluationDescription },
        });
    };

const getGetTestCleanOptionalParams = (optionalParams) => {
    const feeNumbers = get(optionalParams, "feeNumbers");
    const valueCode = get(optionalParams, "valueCode");
    const eventCode = get(optionalParams, "eventCode");
    let normalizedFeeNumbers = "";

    if (feeNumbers == null) {
        normalizedFeeNumbers = undefined;
    } else if (feeNumbers == BROKER_CONVENIENCE_MIFID_EMPTY_FEE_NUMBERS) {
        normalizedFeeNumbers = BROKER_CONVENIENCE_MIFID_EMPTY_FEE_NUMBERS;
    } else {
        normalizedFeeNumbers = Number(feeNumbers);
    }

    return {
        feeNumbers: normalizedFeeNumbers,
        valueCode: valueCode == null ? undefined : trim(valueCode),
        eventCode: eventCode == null ? undefined : trim(eventCode),
    };
};

const fetchGetTestFetching = () => ({
    type: BROKER_CONVENIENCE_MIFID_TEST_FETCH_GET_TEST_FETCHING,
});

const fetchGetTestSuccess = (response, optionalParams) => ({
    type: BROKER_CONVENIENCE_MIFID_TEST_FETCH_GET_TEST_SUCCESS,
    payload: { response, optionalParams },
});

const getInvestmentExperienceSuccess = dataInvestmentExperience => {
    return {
        type: BROKER_CONVENIENCE_MIFID_TEST_GET_INVESTMENT_EXPERIENCE_SUCCESS,
        payload: { dataInvestmentExperience },
    };
};

const handleCloseModalInvestmentExperience = () => {
    return {
        type: BROKER_CONVENIENCE_MIFID_TEST_HANDLE_CLOSE_MODAL_INVESTMENT_EXPERIENCE,
    };
};

const getInvestmentExperience = (dispatch, getState) => {

    const immFlagBasedFeatures = getState().flagBasedFeatures;
    if (
        immFlagBasedFeatures.get(
            MIFID_TEST_CONTRACTED_PRODUCTS_COHERENCE_CONTROL,
        )
    ) {
        const requestData = {
            header: {
                version: 2,
            },
        };

        return APIGet(
            dispatch,
            apiURLBuilder.getURL('brokerInvestmentExperience'),
            requestData,
        );
    }
};

const getAnswerAccordingToTime = timesHired => {
    if (timesHired === 0) {
        return 'Ninguna';
    } else if (timesHired === 1) {
        return '1';
    } else if (timesHired >= 2) {
        return '2 o más';
    }
};

const fetchGetTest =
    (operationCode, isinId, marketId, optionalParams, history) =>
    (dispatch, getState) => {
        const immFlagBasedFeatures = getState().flagBasedFeatures;
        const cleanOptionalParams =
            getGetTestCleanOptionalParams(optionalParams);
        const url = apiURLBuilder.getURL("brokerMiFIDGetTest");
        const testV3FF = immFlagBasedFeatures.get(CONVENIENCE_TEST_V3)
        const requestData = {
            header: {
                version: testV3FF ? 3 : 2,
            },
            query: {
                language: getLanguage().toLowerCase(),
                canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
                operationCode,
                isinId,
                marketId,
                feeNumbers: cleanOptionalParams.feeNumbers,
                valueCode: cleanOptionalParams.valueCode,
                eventCode: cleanOptionalParams.eventCode,
            },
        };

        dispatch(fetchGetTestFetching());
        return APIGet(dispatch, url, requestData).then(
            (response) => {
              if (immFlagBasedFeatures.get(MIFID_TEST_CONTRACTED_PRODUCTS_COHERENCE_CONTROL)) {
                const experienceRequestData ={
                  header: {
                      version: 2,
                  }
                }
                return APIGet(
                  dispatch,
                  apiURLBuilder.getURL('brokerInvestmentExperience'),
                  experienceRequestData,
                ).then(
                    (experienceResponse) => {
                        const allTests = response.getTestListado;
                        const testToEvaluateId = response.tipoTestEvaluado;
                        const indexTest = allTests.findIndex(
                            (test) => testToEvaluateId === test.tipoTest
                        );
                        const testToEvaluate = allTests.find(
                            (test) => testToEvaluateId === test.tipoTest
                        );
                        if (
                            !!experienceResponse &&
                            testToEvaluate.lastDateTest === null &&
                            testToEvaluate.score === null
                        ) {
                            const listAnswers = [
                                { id: "241", option: "A" },
                                { id: "245", option: "B" },
                                { id: "257", option: "E" },
                                { id: "261", option: "F" },
                                { id: "265", option: "G" },
                                { id: "273", option: "I" },
                            ];
                            experienceResponse.forEach((experience) => {
                                const timeHired = experience.timesHired;
                                const answer = listAnswers.find(
                                    (element) =>
                                        element.option ===
                                        experience.productFamilyId
                                );
                                if (answer) {
                                    const test =
                                        testToEvaluate.test.question.find(
                                            (test) => test.id === answer.id
                                        );
                                    if (test) {
                                        const descriptionToAnswer =
                                            getAnswerAccordingToTime(timeHired);
                                        test.answer.forEach((element) => {
                                            if (
                                                element.description ==
                                                descriptionToAnswer
                                            ) {
                                                element.selected = "S";
                                            }
                                        });
                                    }
                                }
                            });
                            response.getTestListado[indexTest] = testToEvaluate;
                            dispatch(handleCloseModalInvestmentExperience())
                            dispatch(fetchGetTestSuccess(response, cleanOptionalParams));
                          } else {
                            dispatch(fetchGetTestSuccess(response, cleanOptionalParams));
                          }
                    }
                ).catch(()=>{
                  dispatch(fetchGetTestSuccess(response, cleanOptionalParams))
                });
              } else {
                dispatch(fetchGetTestSuccess(response, cleanOptionalParams))
              }
            },
            (error) => {
              dispatch(errorActions.show('', true, history));
              throw error;
            }
        );
    };

const mifidDisclaimersResponse = (immBrokerConvenienceMiFIDTest) => {
    const isUsingMifidv2 =
        immBrokerConvenienceMiFIDTest.get("mifidVersion") ===
        BROKER_MIFID_VERSION_2;
    let disclaimers = undefined;

    if (isUsingMifidv2) {
        const mifidv2AllDisclaimers = immBrokerConvenienceMiFIDTest
            .getIn(["mifidv2", "disclaimers"])
            .merge(
                immBrokerConvenienceMiFIDTest.getIn([
                    "mifidv2",
                    "usPersonDisclaimers",
                ])
            )
            .toJS();

        disclaimers = reduce(
            mifidv2AllDisclaimers,
            (result, disclaimer, index) => {
                const disclaimerKey = `disclaimer_${index + 1}`;
                const disclaimerText = trim(get(disclaimer, "description"));

                result[disclaimerKey] = disclaimerText;

                return result;
            },
            {}
        );
    }

    return disclaimers;
};

const getCurrentTestScoreFetching = () => ({
    type: BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_FETCHING,
});

const getCurrentTestScoreSuccessApproved = () => ({
    type: BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_SUCCESS_APPROVED,
});

const getCurrentTestScoreSuccessDisapproved = () => ({
    type: BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_SUCCESS_DISAPPROVED,
});

const getCurrentTestScoreError = () => ({
    type: BROKER_CONVENIENCE_MIFID_TEST_FETCH_CURRENT_TEST_RESULT_ERROR,
});

const getCurrentTestScore = (history) => (dispatch, getState) => {
    const url = apiURLBuilder.getURL("brokerGetCurrentTestScore");
    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'testToEvaluate','tipoTest'])
    if (isPrivateEquityTest(testToEvaluateId)) {
        return dispatch(getCurrentTestScoreSuccessApproved());
    }
    const requestData = {
        language: getLanguage().toLowerCase(),
        test: formatTestQuestions(immBrokerConvenienceMiFIDTest),
        onlyType1: !isPrivateEquityTest(testToEvaluateId),
    };
    dispatch(getCurrentTestScoreFetching());
    return APIPost(dispatch, url, { query: requestData }).then(
        (response) => {
            if (response.result === "A") {
                dispatch(getCurrentTestScoreSuccessApproved());
            } else {
                dispatch(getCurrentTestScoreSuccessDisapproved());
            }
        },
        () => {
            dispatch(getCurrentTestScoreError());
            dispatch(errorActions.show("", true, history));
        }
    );
};

const reviewDisapprovedTest = () => (dispatch) => {
    const firstStep = isRenderStep0() ? THIRD_STEP : SECOND_STEP;
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_REVIEW_DISAPPROVED_TEST,
        payload: {
            step: firstStep,
        },
    });
};

const continueWithDisapprovedTest = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_CONTINUE_WITH_DISAPPROVED_TEST,
    });
};

const resetCurrentTestScoreStatus = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_RESET_TEST_SCORE_STATUS,
    });
};

const resetStepsToInitialState = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEPS_INITIAL_STEPS,
    });
};

const updateCurrentCategory = (newConfiguration) => ({
    type: BROKER_CONVENIENCE_MIFID_TEST_UPDATE_CATEGORY_AND_SUBCATEGORY,
    payload: newConfiguration,
});

const changeEnableButton = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_ENABLE_BUTTON,
    });
};

const changeDisabledButton = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_DISABLED_BUTTON,
    });
};

const getStoreForValidateTest = (getState) => {
    const immTest = getState().brokerConvenienceMiFIDTest.get("test");
    const immSchema = immTest.get("schema");
    const immCategories = immSchema.get("categories");
    const immTestState = immTest.get("testState");
    const currentStepCategory = immTestState.get("currentStepCategory");
    const currentStepSubCategory = immTestState.get("currentStepSubCategory");
    const immSubCategory = immCategories.getIn([
        currentStepCategory,
        "subCategories",
        currentStepSubCategory,
    ]);
    const immSections = immSubCategory.get("sections");

    return {
        immTest,
        immSchema,
        immCategories,
        immTestState,
        currentStepCategory,
        currentStepSubCategory,
        immSubCategory,
        immSections,
    };
};

const validatePreviousTest = () => (dispatch, getState) => {
    const { immSections } = getStoreForValidateTest(getState);
    const questions = immSections.toJS();
    const answerForQuestion = questions.reduce((acc, section) => {
        acc.push(...section.questions);
        return acc.flat();
    }, []);

    if (answerForQuestion) {
        let answersSelected = [];
        let haveItemSelected = [];
        let isAcordeon = false;
        answerForQuestion.forEach((question) => {
            if (question.inputType === ACCORDION_TYPE) {
                isAcordeon = true;
            } else {
                if (question.inputType === "text") {
                  haveItemSelected = question.answer.filter(
                      (item) => item.selected !== ''
                        && item.selected !== 'N'
                        && item.selected !== 'S'
                  );
                } else {
                  haveItemSelected = question.answer.filter(
                      (item) => item.selected === "S"
                  );
                }
            }

            if (haveItemSelected.length > 0) {
                answersSelected.push(haveItemSelected);
            }
        });

        if (
            answersSelected.length === answerForQuestion.length &&
            !isAcordeon
        ) {
            dispatch(changeDisabledButton());
        } else if (isAcordeon) {
            dispatch(changeDisabledButton());
        } else {
            dispatch(changeEnableButton());
        }
    }
};

const showModalForQuestion204 = (showModal) => ({
    type: BROKER_CONVENIENCE_MIFID_TEST_SHOW_PROFESSIONAL_EXPERIENCE_MODAL,
    payload: showModal,
});

const showProfExpWarningModal = (showModal) => ({
    type: BROKER_CONVENIENCE_MIFID_TEST_SHOW_PROFESSIONAL_EXPERIENCE_MODAL_WARNING,
    payload: showModal,
});

const validateStep = (getState, dispatch) => {
    const { immSections } = getStoreForValidateTest(getState);
    const questions = immSections.toJS();
    const answerForQuestion = questions[0].questions;
    if (answerForQuestion) {
        let validateAnswer = {};
        answerForQuestion.forEach((question) => {
            if (question.inputType === "text") {
                validateAnswer = question.answer.filter(
                    (item) => item.selected !== ''
                    && item.selected !== 'N'
                    && item.selected !== 'S'
                );
            } else {
                validateAnswer = question.answer.filter(
                    (item) => item.selected === "S"
                );
            }
        });
        if (
            validateAnswer.id === ANSWER_205 &&
            answerForQuestion[0].id === QUESTION_204
        ) {
            dispatch(showModalForQuestion204(true));
            return false;
        }
        return true;
    }
};

const addAnswerWithCoherence = (listAnswer) => ({
    type: BROKER_CONVENIENCE_MIFID_TEST_UPDATE_LIST_ANSWER_WITH_COHERENCE,
    payload: listAnswer,
});

const setIsAccordionAnswer = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_IS_ACCORDION_ANSWER,
    });
};

const showModalForCoherenceControl = (showModal) => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_SHOW_MODAL,
        payload: showModal,
    });
};

const showConfirmationStep = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_GO_TO_CONFIRMATION_STEP,
    });
};

const hideTestDifferenceModal = () => dispatch =>{
    dispatch({
       type: BROKER_CONVENIENCE_MIFID_TEST_HIDE_DIFFERENCE_MODAL,
   })
};

const evaluateAccordionsResponses = (state) => {
    const { immSections } = getStoreForValidateTest(state)
    const questions = immSections.toJS();
    const answerForQuestion = questions[0].questions;
    const accordionAnswers = answerForQuestion.map((question) => {
        const answer = question.answer.find((answer, i) => answer.selected === "S" && i !== 2);
        return answer
    });
    return accordionAnswers.every((answer) => !answer)
}


const updateAnswer = (sectionId, questionId, newValue) => (dispatch, getState) => {
    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'testToEvaluate','tipoTest'])
    if (isPrivateEquityTest(testToEvaluateId)) {
        // eslint-disable-next-line no-use-before-define
        const shouldUpdate = dispatch(extraUpdatesForTest7(questionId, newValue));
        if (!shouldUpdate) {
            return;
        }
    }
    return dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_UPDATE_ANSWER,
        payload: {
            sectionId,
            questionId,
            newValue,
            // eslint-disable-next-line no-use-before-define
            error: checkAnswerError(questionId, newValue),
        },
    });
};

const extraUpdatesForTest7 = (questionId, newValue) => (dispatch, getState) => {
    if (questionId === '1' && newValue === 'closeModal') {
        const { immSections } = getStoreForValidateTest(getState);
        const immQuestions = immSections.getIn([0, 'questions']);
        const immQuestion1 = immQuestions.find(immQuestion => immQuestion.get('id') === '1');
        const immAnswerForQuestion1 = immQuestion1.get('answer').find(ans => ans.get('selected') === 'S');
        if (immAnswerForQuestion1.get('id') === '2') {
            dispatch(goToFinishTest());
        }
    } else if (questionId === '45') {
        const { immSections } = getStoreForValidateTest(getState);
        const immIncomesQuestion = immSections.getIn([0, 'questions', 1]);
        const immIncomesAnswer = immIncomesQuestion && immIncomesQuestion.get('answer').find(ans => ans.get('selected') === 'S');
        if (immIncomesAnswer && immIncomesAnswer.get('id') === '51') {
            dispatch({
                type: BROKER_CONVENIENCE_MIFID_TEST_UPDATE_ANSWER,
                payload: {
                    sectionId: 0,
                    questionId: '45',
                    newValue: 0,
                    error: false,
                },
            });
            return false;
        }
    } else if (questionId === '46' && newValue === '51') {
        dispatch(updateAnswer(0, '45', 0));
    } else if(questionId === '58' && newValue === '59') {
        dispatch(updateAnswer(0, '62', null));
        dispatch(updateAnswer(0, '66', null));
        dispatch(updateAnswer(0, '69', null));
        dispatch(updateAnswer(0, '73', null));
    } else if (questionId === '62' && newValue != '65') {
        dispatch(updateAnswer(0, '66', null));
        dispatch(updateAnswer(0, '69', null));
        dispatch(updateAnswer(0, '73', null));
    }
    return true;
}

const checkAnswerError = (questionId, newValue) => {
    if (questionId==="54" && newValue<10000) {
        return true;
    }
    return false;
}

const goToConfirmationStep = () => (dispatch, getState) => {
    const {
        immSections,
        immTest,
        currentStepCategory,
        currentStepSubCategory,
        immCategories,
    } = getStoreForValidateTest(getState);
    const questions = immSections.toJS();
    const answerForQuestion = questions[0].questions;
    const immTestEvaluate = immTest.getIn([
        "testToEvaluate",
        "test",
        "question",
    ]);
    const questionEvaluate = immTestEvaluate.toJS();
    const accordionQuestions = questionEvaluate.filter(
        (question) => question.inputType === ACCORDION_TYPE
    );

    const tags = buildTags({
        immCategories,
        currentStepCategory,
        currentStepSubCategory,
    });
    taggingEventHandled(
        PROC_BROKER_CONVENIENCE_TEST,
        "onFinishTest",
        tags.currentQuestionsTag,
        tags.currentAnswersTag,
        tags.currentStep
    );

    let haveCoherence = false;
    let listAnswer = [];
    const question204 = answerForQuestion.find(q => q.id === '204');
    const answerFor204 = !!question204 && question204.answer.find(a => a.selected === 'S');
    const isHigherResponse = !!answerFor204 && answerFor204.id === '205'
    if (!isHigherResponse) {
        accordionQuestions.forEach((question, index) => {
            const answersEvaluate = question.answer.find(
                (answer) => answer.selected === "S"
            );
            if (answersEvaluate) {
                const actualQuestion = answerForQuestion[index];
                const answerAccordion = actualQuestion.answer.find(
                    (answer) => answer.selected === "S"
                );
                if (answerAccordion.id > answersEvaluate.id) {
                    listAnswer.push({
                        description: actualQuestion.description,
                        answer: answerAccordion,
                        previousAnswer: answersEvaluate,
                    });
                    haveCoherence = true;
                }
            }
        });
    }

    dispatch(hideTestDifferenceModal());

    if (haveCoherence) {
        dispatch(addAnswerWithCoherence(listAnswer));
        dispatch(setIsAccordionAnswer());
        dispatch(showModalForCoherenceControl(true));
    } else if (evaluateAccordionsResponses(getState)) {
        dispatch(showProfExpWarningModal(true));
    } else {
        dispatch(showConfirmationStep());
    }
};

const showTestDifferenceModal = () => ({
    type: BROKER_CONVENIENCE_MIFID_TEST_SHOW_DIFFERENCE_MODAL,
});

const validateWithLastTestAndContinue = () => (dispatch, getState) => {
    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;
    const areAccordionAnswerEmpty = evaluateAccordionsResponses(getState)
    const { immTest } = getStoreForValidateTest(getState);
    const immAllTests = immTest.get('allTests');
    const immAnseredTest = immAllTests.filter(immTest => !!immTest.get('lastDateTest'))
    const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'testToEvaluate','tipoTest'])

    if ( !isPrivateEquityTest(testToEvaluateId) && immAnseredTest.size > 0 && !areAccordionAnswerEmpty ) {
        const immRecentTest = immAnseredTest.maxBy(immTest => moment(immTest.get("lastDateTest"), DATE_FORMAT_API2));
        const recentTestQuestions = immRecentTest.getIn(['test', 'question']).toJS();
        const currentTestQuestions = formatTestQuestions(immBrokerConvenienceMiFIDTest);
        const isV3Test = immBrokerConvenienceMiFIDTest.getIn(['test', 'isV3Test'])
        const questionToEvaluateToPreviousTest = isV3Test
            ? QUESTIONS_TO_EVALUATE_TO_PREVIOUS_TEST_V3
            : QUESTIONS_TO_EVALUATE_TO_PREVIOUS_TEST;

        const testAreEquivalent = questionToEvaluateToPreviousTest.every((id) => {
            const existQuestion = recentTestQuestions.some((q) => q.id === '304')
            let idToSearch = id;
            if(isV3Test && !existQuestion) {
                idToSearch = QUESTIONS_EQUIVALENCE_V3_V2[id]
            }
            const resentTestQuestion = recentTestQuestions.find(q => q.id === idToSearch);
            const resentTestQuestionSelectedAnswer = resentTestQuestion.answer.find( ans => ans.selected === 'S')

            const currentTestQuestion = currentTestQuestions.question.find(q => q.id === id);
            const currentTestQuestionnSelectedAnswer = currentTestQuestion.answer.find( ans => ans.selected === 'S')
            if (!resentTestQuestionSelectedAnswer ||  !currentTestQuestionnSelectedAnswer) {
                return true;
            } else {
                return resentTestQuestionSelectedAnswer.id === currentTestQuestionnSelectedAnswer.id;
            }
        })
        if (testAreEquivalent) {
            dispatch(goToConfirmationStep());
        } else {
            dispatch(showTestDifferenceModal());
        }
    }else {
        dispatch(goToConfirmationStep());
    }
}


const moveToNextStep = () => (dispatch, getState) => {
    const {
        immSchema,
        currentStepCategory,
        currentStepSubCategory,
        immCategories,
    } = getStoreForValidateTest(getState);

    const categoriesLength = immCategories.size;
    const currentSubcategoriesLength = immSchema.getIn([
        "categories",
        currentStepCategory,
        "subCategories",
    ]).size;
    const testToEvaluateId = getState().brokerConvenienceMiFIDTest.getIn(['mifidv2', 'testToEvaluate','tipoTest'])
    if (!isPrivateEquityTest(testToEvaluateId)) {
        const tags = buildTags({
            immCategories,
            currentStepCategory,
            currentStepSubCategory,
        });
        taggingEventHandled(
            PROC_BROKER_CONVENIENCE_TEST,
            "onNextStep",
            tags.currentQuestionsTag,
            tags.currentAnswersTag,
            tags.currentStep
        );
    }

    const isCategoryMove =
        currentStepCategory < categoriesLength &&
        currentStepSubCategory + 1 >= currentSubcategoriesLength;

    const isSubCategoriesMove =
        currentStepSubCategory < currentSubcategoriesLength;
    dispatch(changeEnableButton());

    if (isCategoryMove) {
        return dispatch(
            updateCurrentCategory({
                currentStepCategory: currentStepCategory + 1,
                currentStepSubCategory: 0,
            })
        );
    }

    if (isSubCategoriesMove) {
        return dispatch(
            updateCurrentCategory({
                currentStepCategory: currentStepCategory,
                currentStepSubCategory: currentStepSubCategory + 1,
            })
        );
    }
};

const coherenceControl = () => (dispatch, getState) => {
    const { immSections, immTest } = getStoreForValidateTest(getState);
    const questions = immSections.toJS();
    const testId = immTest.getIn([ 'testToEvaluate', 'tipoTest'])
    let answerForQuestion = questions[0].questions;
    if (isPrivateEquityTest(testId)) {
        answerForQuestion = answerForQuestion.filter(q => q.id !== '1');
    }
    let actualAnswer;
    if (answerForQuestion[0].inputType === "text") {
        actualAnswer = answerForQuestion[0].answer.filter(
            (item) =>
                item.selected !== "" &&
                item.selected !== "N" &&
                item.selected !== "S"
        );
    } else {
        actualAnswer = answerForQuestion[0].answer.find(
            (item) => item.selected === "S"
        );
    }
    if (
        actualAnswer.id === ANSWER_205 &&
        answerForQuestion[0].id === QUESTION_204
    ) {
        dispatch(showModalForQuestion204(true));
    } else {
        if (isPrivateEquityTest(testId) && answerForQuestion[0].id === '6') {
            const generalTest = immTest.get('allTests').find(test => test.get('tipoTest') === 1)
            const generalTestQuestions = generalTest.getIn(['test', 'question']).toJS();
            const generalTestStudyQuestion = generalTestQuestions.find(q => q.id === "208");
            const generalTestStudyAnswer =
                !!generalTestStudyQuestion &&
                generalTestStudyQuestion.answer.find((a) => a.selected === "S");
            const privateEquityStudyAnswer = answerForQuestion[0].answer.find((a) => a.selected === "S");
            if (generalTestStudyAnswer && privateEquityStudyAnswer) {
                const generalTestStudyAnswerWeight = GENERAL_TEST_STUDY_ANSWER_WEIGHTS[generalTestStudyAnswer.id];
                const privateEquityStudyAnswerWeight = PRIVATE_EQUITY_STUDY_ANSWER_WEIGHTS[privateEquityStudyAnswer.id];
                if (privateEquityStudyAnswerWeight < generalTestStudyAnswerWeight) {
                    dispatch(addAnswerWithCoherence([{
                        description: generalTestStudyQuestion.description,
                        answer: privateEquityStudyAnswer,
                        previousAnswer: generalTestStudyAnswer,
                        lastDateTest: generalTest.get('lastDateTest'),
                    }]));
                    dispatch(showModalForCoherenceControl(true));
                    dispatch(changeEnableButton());
                    return;
                }
            }
        }
        if (QUESTION_TO_COHERENCE_CONTROL[answerForQuestion[0].id]) {
            const immTestEvaluate = immTest.getIn([
                "testToEvaluate",
                "test",
                "question",
            ]);
            const questionEvaluate = immTestEvaluate.toJS();
            const listAnswer = questionEvaluate.find(
                (question) => question.id === answerForQuestion[0].id
            );
            const evaluate = listAnswer.answer.find(
                (answer) => answer.selected === "S"
            );
            if (!!evaluate && actualAnswer.id > evaluate.id) {
                const a = {
                    description: answerForQuestion[0].description,
                    answer: actualAnswer,
                    previousAnswer: evaluate,
                    lastDateTest: immTest.getIn([
                        "testToEvaluate",
                        "lastDateTest",
                    ]),
                };
                dispatch(addAnswerWithCoherence([a]));
                dispatch(showModalForCoherenceControl(true));
                dispatch(changeEnableButton());
            } else {
                dispatch(moveToNextStep());
            }
        } else {
            dispatch(moveToNextStep());
        }
    }
};

const goToForwardStep = () => (dispatch, getState) => {
    const { immTest } = getStoreForValidateTest(getState);
    const isFirsTest = immTest.get("isFirsTest");
    if (validateStep(getState, dispatch) && isFirsTest) {
        dispatch(moveToNextStep());
    } else if (!isFirsTest) {
        dispatch(coherenceControl());
    }
};

const goToPreviousStep = () => (dispatch, getState) => {
    const { immCategories } = getStoreForValidateTest(getState);
    const immTest = getState().brokerConvenienceMiFIDTest.get("test");
    const immSchema = immTest.get("schema");
    const immTestState = immTest.get("testState");
    const currentStepCategory = immTestState.get("currentStepCategory");
    const currentStepSubCategory = immTestState.get("currentStepSubCategory");
    const testToEvaluateId = getState().brokerConvenienceMiFIDTest.getIn(['mifidv2', 'testToEvaluate','tipoTest'])
    if (!isPrivateEquityTest(testToEvaluateId)) {
        const tags = buildTags({
            immCategories,
            currentStepCategory,
            currentStepSubCategory,
        });
        taggingEventHandled(
            PROC_BROKER_CONVENIENCE_TEST,
            "onPreviousStep",
            "",
            tags.currentSubCategoryTag || tags.currentCategoryTag
        );
    }

    const isCategoryMove =
        currentStepCategory > 0 && currentStepSubCategory === 0;
    const isSubCategoriesMove = currentStepSubCategory > 0;
    if (isCategoryMove) {
        const newCategory = currentStepCategory - 1;
        const newSubCategoriesLength = immSchema.getIn([
            "categories",
            newCategory,
            "subCategories",
        ]).size;

        return dispatch(
            updateCurrentCategory({
                currentStepCategory: currentStepCategory - 1,
                currentStepSubCategory: newSubCategoriesLength - 1,
            })
        );
    }

    if (isSubCategoriesMove) {
        return dispatch(
            updateCurrentCategory({
                currentStepSubCategory: currentStepSubCategory - 1,
            })
        );
    }
};

const onCancelTest = () => (dispatch, getState) => {
    const testToEvaluateId = getState().brokerConvenienceMiFIDTest.getIn(['mifidv2', 'testToEvaluate','tipoTest'])
    if (!isPrivateEquityTest(testToEvaluateId)) {
        const { currentStepCategory, currentStepSubCategory, immCategories } =
            getStoreForValidateTest(getState);
        const tags = buildTags({
            immCategories,
            currentStepCategory,
            currentStepSubCategory,
        });
        taggingEventHandled(
            PROC_BROKER_CONVENIENCE_TEST,
            "onCancelTest",
            "",
            tags.currentSubCategoryTag || tags.currentCategoryTag
        );
    }
};

const goToFinishTest = () => (dispatch) => {
    taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, "onSuccess");
    return dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_GO_TO_FINISH_STEP,
    });
};

const goToStep =
    (currentStepCategory, currentStepSubCategory) => (dispatch) => {
        dispatch({
            type: BROKER_CONVENIENCE_MIFID_TEST_GO_TO_STEP,
            payload: {
                currentStepCategory,
                currentStepSubCategory,
            },
        });
    };
const onReviewingTest = () => (dispatch, getState) => {
    const { currentStepCategory, currentStepSubCategory, immCategories } =
        getStoreForValidateTest(getState);

    const tags = buildTags({
        immCategories,
        currentStepCategory,
        currentStepSubCategory,
    });
    taggingEventHandled(
        PROC_BROKER_CONVENIENCE_TEST,
        "onReviewingTest",
        tags.currentQuestionsTag,
        tags.currentAnswersTag,
        tags.currentStep
    );
    dispatch(showModalForQuestion204(false));

    return dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_REVIEWING_TEST,
    });
};

const hideFirstTimePopUp = () => dispatch => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_HIDE_FIRST_TIME_POP_UP,
    });
}

module.exports = {
    resultDisplayed,
    hardReset,
    reset,
    validateStep,
    setVisibleStep,
    start,
    startFromCorporateOperation,
    startFromFund,
    finish,
    omit,
    consult,
    retakeTest,
    fetchGetTest,
    mifidDisclaimersResponse,
    resetStepsToInitialState,
    reviewDisapprovedTest,
    resetCurrentTestScoreStatus,
    continueWithDisapprovedTest,
    getCurrentTestScore,
    goToForwardStep,
    changeDisabledButton,
    changeEnableButton,
    goToPreviousStep,
    updateAnswer,
    goToConfirmationStep,
    goToFinishTest,
    goToStep,
    validatePreviousTest,
    showModalForCoherenceControl,
    moveToNextStep,
    showConfirmationStep,
    onReviewingTest,
    showModalForQuestion204,
    showProfExpWarningModal,
    onCancelTest,
    validateWithLastTestAndContinue,
    hideTestDifferenceModal,
    hideFirstTimePopUp,
    handleCloseModalInvestmentExperience,
    addPrivateEquityDisclaimers
};
